import {
	Table,
	TableBody,
	TableCell,
	TableHead,
	TableHeader,
	TableRow,
} from "@/components/ui/table";

const SKELETON_ROWS = ["alpha", "bravo", "charlie"];

type MaterialRequestPrintRow = {
	id?: string | number | null;
	requestNumber?: string | number | null;
	client?: {
		name?: string | null;
	} | null;
	material?: {
		description?: string | null;
	} | null;
	quantity?: number | null;
	price?: number | null;
};

type MaterialRequestPrintTableProps = {
	data: MaterialRequestPrintRow[];
	loading?: boolean;
};

const getRowKey = (entry: MaterialRequestPrintRow) =>
	entry.id ?? entry.requestNumber ?? `${entry.client?.name ?? "row"}`;

const renderSkeleton = () => (
	<TableBody>
		{SKELETON_ROWS.map((rowKey) => (
			<TableRow
				key={`request-print-skeleton-${rowKey}`}
				className="animate-pulse"
			>
				<TableCell>
					<div className="h-4 w-12 rounded bg-muted/70" />
				</TableCell>
				<TableCell>
					<div className="h-4 w-32 rounded bg-muted/60" />
				</TableCell>
				<TableCell>
					<div className="h-4 w-40 rounded bg-muted/50" />
				</TableCell>
				<TableCell>
					<div className="h-4 w-12 rounded bg-muted/50" />
				</TableCell>
				<TableCell>
					<div className="h-4 w-16 rounded bg-muted/40" />
				</TableCell>
			</TableRow>
		))}
	</TableBody>
);

const renderEmpty = () => (
	<TableBody>
		<TableRow>
			<TableCell
				colSpan={5}
				className="py-10 text-center text-sm text-muted-foreground"
			>
				Sem pedidos para imprimir.
			</TableCell>
		</TableRow>
	</TableBody>
);

export function MaterialRequestPrintTable({
	data,
	loading = false,
}: MaterialRequestPrintTableProps) {
	return (
		<div className="overflow-hidden rounded-lg border border-border/60 bg-card/70">
			<Table>
				<TableHeader>
					<TableRow className="bg-muted/50">
						<TableHead className="w-[90px] text-center">#Pedido</TableHead>
						<TableHead className="w-[200px]">Cliente</TableHead>
						<TableHead className="w-[200px]">Material</TableHead>
						<TableHead className="w-[90px]">Qnt.</TableHead>
						<TableHead className="w-[90px]">Preço</TableHead>
					</TableRow>
				</TableHeader>
				{loading ? (
					renderSkeleton()
				) : data.length > 0 ? (
					<TableBody>
						{data.map((entry) => (
							<TableRow key={getRowKey(entry)}>
								<TableCell className="text-center">
									{entry.requestNumber ?? "-"}
								</TableCell>
								<TableCell>{entry.client?.name ?? "-"}</TableCell>
								<TableCell>{entry.material?.description ?? "-"}</TableCell>
								<TableCell>{entry.quantity ?? "-"}</TableCell>
								<TableCell>{entry.price ?? "-"}</TableCell>
							</TableRow>
						))}
					</TableBody>
				) : (
					renderEmpty()
				)}
			</Table>
		</div>
	);
}
